/**
 * 权利要求分析结果 DTO
 * Claim analysis result data structure
 */
export interface ClaimAnalysisResult {
    /** 涉及的权利要求（如 '1', '2-3', '5-6'） */
    claim_involved?: string;

    /** 审查员的对比分析 */
    examiner_comparison?: string;

    /** 核实结论 */
    verification_conclusion?: string;

    /** 对比文件公开/常识/未公开的内容分析 */
    disclosed_common_knowledge_not_disclosed?: string;

    /** 论证强度评估（强/中/弱） */
    argument_strength?: string;

    /** 推荐的应对行动 */
    recommended_action?: string;

    /** 策略建议 */
    strategy_recommendation?: string;

    /** 论证特征（逗号分隔） */
    argument_features?: string;
}

/**
 * Request body for previewStatementPrompt API
 * 陈述书导出请求
 */
export interface RequestBody {
    /** OAR task ID (required) */
    task_id: string;

    /** 权利要求分析结果列表（由客户端调用权利要求分析服务后传入） */
    analyze_opinions_result?: ClaimAnalysisResult[];
}

/**
 * Combined request parameters
 */
export interface PreviewStatementPromptRequestParams {
    /** Request body */
    body: RequestBody;
}

/**
 * Response data interface
 * 陈述书 Prompt 预览响应
 */
export interface PreviewStatementPromptResponseData {
    /** 生成的 Prompt 内容 */
    prompt: string;
}

/**
 * API interface for previewStatementPrompt
 * 预览陈述书 Prompt
 *
 * 根据OAR任务生成陈述书的 AI Prompt 内容，用于预览或调试，不实际调用 AI 服务
 */
export interface PreviewStatementPromptApi {
    /**
   * Preview statement prompt
   * 预览陈述书 Prompt
   *
   * @param params - Request parameters including request body
   * @returns Promise resolving to prompt preview response
   */
    previewStatementPrompt(params: PreviewStatementPromptRequestParams): Promise<PreviewStatementPromptResponseData>;
}

/**
 * Symbol for dependency injection
 */
export const PreviewStatementPromptApi = Symbol.for('PreviewStatementPromptApi');
